import React, {Component} from 'react';
// helpers
import { getTennisOrBaseballMarketName} from '../../../helpers/marketHelpers';
import {getText} from '../../../../../helpers/localization';
// components
import LockedBet from '../../../components/lockedBet';
import {PLACED, VOIDED} from "../../../../../constants/identifiers";
import style from "../../../css/lockedBetCricket.css";
import {getGameTitle} from "../../../../../helpers/eventHelpers";
import {ALL_TENNIS_MARKETS} from "../constants/marketTypes";
import {getMarketByCode} from '../helpers/marketHelpers'


class LockedBetTennis extends Component {

    _createEventDetails(eventDetails,bet) {
        let playerOne = eventDetails.team1;
        let teamScore = eventDetails.fullTimeResult.split(";")[0];
        let winner = eventDetails.fullTimeResult.split(";")[1].split(" ")[1];
        let marketWithWinningSelections = eventDetails.fullTimeResult
          .split(";")
          .slice(2, eventDetails.fullTimeResult.split(";").length);
        let playerSelectionMarketCode = bet.Market.Code;
        let playerSelectionMarketName = getMarketByCode(
          playerSelectionMarketCode
        ).name;
        let winMarketSelection;
        let marketWithWinningSelection;
        if (
          playerSelectionMarketCode !== "218" &&
          playerSelectionMarketCode !== "221"
        ) {
          for (let i = 0; i < marketWithWinningSelections.length; i++) {
            if (
              marketWithWinningSelections[i].length > 0 &&
              marketWithWinningSelections[i]
                .split("::")[0]
                .includes(playerSelectionMarketCode)
            ) {
              marketWithWinningSelection = marketWithWinningSelections[i];
              break;
            }
          }
          switch (marketWithWinningSelection.split("::")[0].trim()) {
            case "219":
              winMarketSelection = marketWithWinningSelection
                .split("::")[2].trim().split(" ").slice(1).join(" ")
                .replace(" To Win", "");
              break;
            case "220":
              winMarketSelection = getText(
                marketWithWinningSelection.split("::")[2].trim().split(" ")[0],
                this.props.store,
                [marketWithWinningSelection.split("::")[2].trim().split(" ")[1]]
              );
              break;
            case "222":
              let marketSelection = marketWithWinningSelection.split("::")[2]
              let playerName =
                marketSelection.includes(playerOne)
                  ? eventDetails.team1.split(" ")[1]
                  : eventDetails.team2.split(" ")[1];
              winMarketSelection = playerName + " "
                + getText(
                  marketSelection.split(" ").slice(3, marketSelection.split(" ").length).join(" ").trim(),
                  this.props.store
                );

              break;
            default:
              break;
          }
        }

        return (
          <div>
            <div className={`${style.eventDetailsLine} ${style.even}`}>
              <div className={style.eventDetailsLineLeft}>
                {getText("MATCH_WINNER", this.props.store)}
              </div>
              <div className={style.eventDetailsLineRight}>{winner}</div>
            </div>
            <div className={`${style.eventDetailsLine}`}>
              <div className={style.eventDetailsLineLeft}>
                {getText("CORRECT_SCORE", this.props.store)}
              </div>
              <div className={style.eventDetailsLineRight}>{teamScore}</div>
            </div>
            {playerSelectionMarketCode !== "218" &&
              playerSelectionMarketCode !== "221" && (
                <div className={`${style.eventDetailsLine} ${style.even}`}>
                  <div className={style.eventDetailsLineLeft}>
                    {getText(playerSelectionMarketName, this.props.store)}
                  </div>
                  <div className={style.eventDetailsLineRight}>
                    {winMarketSelection}
                  </div>
                </div>
              )}
          </div>
        );
    }

    render() {
        let eventDetails;
        let bet = this.props.betSelection.Bets[0];
        let marketTypeList = ALL_TENNIS_MARKETS;
        let marketInfo = bet.OpaqueData === undefined ? null : JSON.parse(bet.OpaqueData);
        let selection = marketInfo && marketInfo.tennisSelection;
        let teamOne = bet.EventDetails.team1;
        let teamTwo = bet.EventDetails.team2;
    

        let homeTeam = teamOne.split(" ")[1];
        let awayTeam = teamTwo.split(" ")[1];
        let voidStatus = bet.State === 'VOIDED';
        let title = `${teamOne} ${getText('VS', this.props.store)} ${teamTwo}`;
        let eventName = getGameTitle(title, bet.EventTime, this.props.store.getState().vpp.systemLanguage);
        let betType = getText(getTennisOrBaseballMarketName(bet.Market.Code,marketTypeList), this.props.store, [homeTeam, awayTeam]);
        let odd = bet.Market.Price;
        let name = '';
        if (marketInfo !== null) {
            switch (Number(marketInfo.marketCode)) {
                case 218:
                    name = selection.split(" ")[1];
                    break;
                case 219:
                    name = selection.replace("Player 1", homeTeam).replace("Player 2", awayTeam).replace("To Win", "")
                    .trim();
                  break;
                case 220:
                    name = getText(
                    selection.split(" ")[0],
                    this.props.store,
                    [selection.split(" ")[1]]
                  );
                  break;
                case 221:
                    name = selection;
                  break;
                case 222:
                    name = (selection.includes("Player 1")) ? homeTeam +" "+ getText(selection
                        .replace("Player 1", "")
                        .trim(), this.props.store)
                    : awayTeam +" "+ getText(selection
                        .replace("Player 2", "")
                        .trim(), this.props.store);
                  break;
                default:
                    name = getText(selection, this.props.store);
                  break;
              }
        }

        if (this.props.betsType !== PLACED && this.props.betsType !== VOIDED && !voidStatus) {
            eventDetails = (
                <div className={style.eventDetailsWrapper}>
                    <div className={style.eventDetails}>
                        {this._createEventDetails(bet.EventDetails,bet)}</div>

                </div>
            );
            eventName.score = eventName.gameTitle;
            eventName.formated = (<div className={style.cricketTitle}>
                <div className={style.eventTime}>{`${eventName.dayMonthYear} `}{`${eventName.hoursMinutes} `}</div>
                <p className={style.resultContainer}>
                    {`${homeTeam} `}{` ${bet.EventDetails.fullTimeResult.split('').join(' ')} `}{` ${awayTeam}`}</p>
            </div>);
        }

        return (<LockedBet store={this.props.store} index={this.props.index} betSelection={this.props.betSelection}
                           betType={betType} odd={odd} eventName={eventName} names={[name]}
                           isSettledBet={this.props.isSettledBet} eventDetails={eventDetails}
                           voidStatus={voidStatus}/>);
    }
}

export default LockedBetTennis;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/tennis/components/lockedBetTennis.js